import React from "react";
import { Link } from "react-router-dom";

export const PromoTitles = ({ promoTiles }) => {
    return (
        <div className="promo_titles">
            {promoTiles.map(
                ({ id, nombre_boton, foto, hash_foto, url, formato }) => {
                    return (
                        <div
                        key={id}
                            style={{
                                background: `url(/storage/promos/${id}/${hash_foto})`
                            }}
                            className="promo"
                        >
                            <a
                                target={
                                    formato === "externa" ? "_blank" : "_self"
                                }
                                rel="noopener noreferrer"
                                href={url}
                            >
                                {nombre_boton}
                                <img
                                    className="ml-half"
                                    src="/images/icons/small.svg"
                                />
                            </a>
                        </div>
                    );
                }
            )}
        </div>
    );
};
